export var IOSDevice;
(function (IOSDevice) {
    IOSDevice["IPAD"] = "iPad";
    IOSDevice["IPHONE"] = "iPhone";
})(IOSDevice || (IOSDevice = {}));
